<template>
  <f7-page>
    <div class="px-4 sm:px-16 py-3">
      <div>
        <div v-if="selectedID === null">
          <div class="flex items-center my-8">
            <img
              class="w-32"
              :src="instance.logoUrl"
              alt="logo"
            >
            <div class="text-3xl ml-4 font-bold leading-none">
              {{ instance.name }} nos <span class="text-purple-500">cuida</span>
            </div>
          </div>
        </div>
        <div class="flex space-x-2 flex-wrap">
          <div>
            <div
              class="flex p-2 justify-between items-center text-white bg-purple-500 rounded-md cursor-pointer"
              @click="showCalendar = !showCalendar"
            >
              <div
                class="text-2xl font-bold"
              >
                {{ formattedDate }}
              </div>
              <eva-icon
                :name="showCalendar ? 'arrow-ios-downward-outline' : 'arrow-ios-forward-outline'"
                fill="#FFFFFF"
              />
            </div>
            <div class="absolute mt-2 shadow-lg z-50">
              <vc-date-picker
                v-if="showCalendar"
                v-model="date"
                :value="null"
                color="purple"
                :attributes="attributes"
                :max-date="new Date()"
              />
            </div>
          </div>
          <div>
            <div
              class="flex items-center text-purple-500 h-full text-lg rounded-md p-1 cursor-pointer border-purple-200 border mt-2 md:mt-0"
              @click="togglePopulationCRUD"
            >
              <eva-icon
                name="plus-outline"
                fill="#6C63FF"
              />
              Nueva Población
            </div>
            <population-crud
              v-if="showingPopulationCRUD"
              class="absolute mt-2 shadow-lg z-50"
              @close="togglePopulationCRUD"
            />
          </div>
          <div
            class="flex items-center text-purple-500 text-lg rounded-md p-1 cursor-pointer border-purple-200 border mt-4 md:mt-0"
            @click="exportAllPopulations"
          >
            <eva-icon
              name="cloud-download-outline"
              fill="#6C63FF"
            />
            Consolidado
          </div>
          <div
            v-if="instanceID === '9FINcMqh3m1DbdhXm90s'"
            class="flex items-center text-purple-500 text-lg rounded-md p-1 cursor-pointer border-purple-200 border mt-4 md:mt-0"
            @click="exportAnswers"
          >
            <eva-icon
              name="cloud-download-outline"
              fill="#6C63FF"
            />
            Salud mental
          </div>
        </div>
      </div>
      <transition-group
        v-if="lastDaysSymptoms && populationHistory"
        name="list"
        mode="out-in"
        class="flex flex-wrap"
      >
        <population-card
          v-if="selectedID === null || selectedID == 'global'"
          key="globalPopulation"
          :special="true"
          populationID="global"
          :population="globalPopulation"
          title="Toda la comunidad"
          @expanded="selectID"
        />
        <population-card
          v-if="selectedID === null || selectedID == 'noReports'"
          key="noReportsPopulation"
          :special="true"
          populationID="noReports"
          :population="noReportsPopulation"
          title="Sin reporte hoy"
          @expanded="selectID"
        />
        <population-card
          v-if="selectedID === null || selectedID == 'symptomatic'"
          key="symptomaticPopulation"
          :special="true"
          populationID="symptomatic"
          :population="symptomaticPopulation"
          title="Sintomáticos últimos días"
          @expanded="selectID"
        />
        <population-card
          v-if="askForVaccinationTagIDs && (selectedID === null || selectedID == 'vaccinated')"
          key="vaccinated"
          :special="true"
          populationID="vaccinated"
          :population="vaccinatedPopulation"
          title="Vacunados"
          @expanded="selectID"
        />
        <population-card
          v-if="askForVaccinationTagIDs && (selectedID === null || selectedID == 'unvaccinated')"
          key="unvaccinated"
          :special="true"
          populationID="unvaccinated"
          :population="unvaccinatedPopulation"
          title="No vacunados"
          @expanded="selectID"
        />
        <population-card
          v-if="askForVaccinationTagIDs && (selectedID === null || selectedID == 'wontGetVaccinated')"
          key="wontGetVaccinatedPopulation"
          :special="true"
          populationID="wontGetVaccinated"
          :population="wontGetVaccinatedPopulation"
          title="No se vacunarán"
          @expanded="selectID"
        />
        <population-card
          v-for="population in selectedPopulations"
          :key="population.id"
          :populationID="population.id"
          :today="population.today"
          :population="population"
          @expanded="selectID"
        />
      </transition-group>
    </div>
  </f7-page>
</template>
<script>
import { db, timestamp } from '../utils/firebase'
import populationCard from '../components/populationCard'
import PopulationCrud from '@/components/populationCrud'
import moment from 'moment-timezone'
import XLSX from 'xlsx'
import { saveAs } from 'file-saver'

import { mapState } from 'vuex'
export default {
  name: 'AdminDashboard',
  components: {
    populationCard,
    PopulationCrud,
  },
  data () {
    return {
      bindings: [],
      populationBindings: [],
      bindedPopulations: [],
      selectedID: null,
      date: moment().tz('America/Bogota').startOf('day').toDate(),
      showCalendar: false,
      globalReportedCount: 0,
      globalSymptomaticCount: 0,
      showingPopulationCRUD: false,
      newPopulationHistoryStructure: false,
      attributes: [
        {
          key: 'today',
          dot: 'purple',
          dates: new Date(),
        }
      ],
    }
  },
  computed: {
    askForVaccinationTagIDs () {
      if (!this.instance || !this.instance.dictionary) {
        return []
      }
      return this.instance.dictionary.parameters.askForVaccinationTagIDs
    },
    timestamp () {
      return moment(this.date).tz('America/Bogota').format('x')
    },
    formattedDate () {
      return moment(this.date).tz('America/Bogota').format('dddd, DD MMM YYYY')
    },
    totalGuest () {
      return this.persons.filter(person => person.guest).length // TODO: do this from binding on vuex
    },
    totalInactive () {
      return this.persons.filter(person => person.active === false).length // TODO: do this from binding on vuex
    },
    personIDs () {
      return this.persons.filter(person => {
        return !person.guest && person.active !== false
      }).map(person => person.id)
    },
    selectedPopulations () {
      return this.populations.filter(population => {
        return this.selectedID === null || this.selectedID === population.id
      }).map(selected => {
        selected.today = moment(this.date).tz('America/Bogota').startOf('day').toDate()
        return selected
      })
    },
    globalPopulation () {
      return {
        instanceID: this.instanceID,
        reportedCount: this.lastDaysSymptoms[this.timestamp] ? this.lastDaysSymptoms[this.timestamp].reportedCount : 0,
        symptomaticCount: this.lastDaysSymptoms[this.timestamp] ? this.lastDaysSymptoms[this.timestamp].symptomaticCount : 0,
        // eslint-disable-next-line new-cap
        lastUpdated: new timestamp.fromDate(moment().tz('America/Bogota').toDate()),
        today: moment(this.date).tz('America/Bogota').startOf('day').toDate(),
        personCount: this.persons.length - this.totalGuest - this.totalInactive,
        personIDs: this.personIDs,
      }
    },
    symptomaticPopulation () {
      const symptomatic = Object.keys(this.lastDaysSymptoms).map(timestamp => {
        if (this.lastDaysSymptoms[timestamp].riskyPersons) {
          return Object.keys(this.lastDaysSymptoms[timestamp].riskyPersons || {})
        }
        return Object.keys(this.lastDaysSymptoms[timestamp].symptoms || {})
      }).flat()
      const uniqueSymptomatic = [...new Set(symptomatic)].filter(personID => this.personIDs.indexOf(personID) > -1)
      return {
        instanceID: this.instanceID,
        reportedCount: uniqueSymptomatic.length,
        symptomaticCount: uniqueSymptomatic.length,
        // eslint-disable-next-line new-cap
        lastUpdated: new timestamp.fromDate(moment().tz('America/Bogota').toDate()),
        today: moment(this.date).tz('America/Bogota').startOf('day').toDate(),
        personCount: uniqueSymptomatic.length,
        personIDs: uniqueSymptomatic,
      }
    },
    noReportsPopulation () {
      const today = moment(this.date).tz('America/Bogota').startOf('day').format('x')
      let noReportPersonIDs = []
      if (this.lastDaysSymptoms[today] && this.lastDaysSymptoms[today].reported) {
        noReportPersonIDs = this.personIDs.filter(personID => {
          return !this.lastDaysSymptoms[today].reported.includes(personID)
        })
      }
      return {
        instanceID: this.instanceID,
        reportedCount: noReportPersonIDs.length,
        symptomaticCount: noReportPersonIDs.length,
        // eslint-disable-next-line new-cap
        lastUpdated: new timestamp.fromDate(moment().tz('America/Bogota').toDate()),
        today: moment(this.date).tz('America/Bogota').startOf('day').toDate(),
        personCount: noReportPersonIDs.length, // FIXME: not the total
        personIDs: noReportPersonIDs,
      }
    },
    vaccinatedPopulation () {
      const vaccinated = this.persons.filter(person => {
        return person.vaccinationStatus && (person.vaccinationStatus.value === 'vaccinated')
      }).map(person => {
        return person.id
      })
      return {
        instanceID: this.instanceID,
        reportedCount: vaccinated.length,
        symptomaticCount: vaccinated.length,
        // eslint-disable-next-line new-cap
        lastUpdated: new timestamp.fromDate(moment().tz('America/Bogota').toDate()),
        today: moment(this.date).tz('America/Bogota').startOf('day').toDate(),
        personCount: vaccinated.length,
        personIDs: vaccinated,
      }
    },
    unvaccinatedPopulation () {
      const unvaccinated = this.persons.filter(person => {
        return (person.vaccinationStatus && person.vaccinationStatus.value === 'unvaccinated')
      }).map(person => {
        return person.id
      })
      return {
        instanceID: this.instanceID,
        reportedCount: unvaccinated.length,
        symptomaticCount: unvaccinated.length,
        // eslint-disable-next-line new-cap
        lastUpdated: new timestamp.fromDate(moment().tz('America/Bogota').toDate()),
        today: moment(this.date).tz('America/Bogota').startOf('day').toDate(),
        personCount: unvaccinated.length,
        personIDs: unvaccinated,
      }
    },
    wontGetVaccinatedPopulation () {
      const wontGetVaccinated = this.persons.filter(person => {
        return person.vaccinationStatus && (person.vaccinationStatus.value === 'wontGetVaccinated')
      }).map(person => {
        return person.id
      })
      return {
        instanceID: this.instanceID,
        reportedCount: wontGetVaccinated.length,
        symptomaticCount: wontGetVaccinated.length,
        // eslint-disable-next-line new-cap
        lastUpdated: new timestamp.fromDate(moment().tz('America/Bogota').toDate()),
        today: moment(this.date).tz('America/Bogota').startOf('day').toDate(),
        personCount: wontGetVaccinated.length,
        personIDs: wontGetVaccinated,
      }
    },
    ...mapState({
      persons: state => state.admin.persons,
      populations: state => state.admin.populations,
      instanceID: state => state.admin.instanceID,
      instance: state => state.admin.instance,
      instancesInfo: state => state.auth.instancesInfo,
      lastDaysSymptoms: state => state.admin.lastDaysSymptoms,
      populationHistory: state => state.admin.populationHistory,
    }),
  },
  watch: {
    instanceID: function () {
      this.bindPopulationsInfo()
    },
    date: function () {
      this.showCalendar = false
      this.bindPopulationsInfo()
    },
    selectedPopulations: function () {
      this.setPopulationBinds()
    },
  },
  mounted () {
    this.bindPopulationsInfo()
  },
  destroyed () {
    this.clearBindings()
  },
  methods: {
    async exportAnswers () {
      const startDate = moment(this.date).tz('America/Bogota').startOf('month').toDate()
      console.info(startDate)
      const personQuery = await db.collection('instances').doc('9FINcMqh3m1DbdhXm90s').collection('persons').get()
      const answerQuery = await db.collection('answers').where('timestamp', '>', startDate).orderBy('timestamp', 'desc').orderBy('answers.s8bjYTD8jQz3rVpDuA9a').get()
      // await Promise.all(promises)
      const persons = personQuery.docs.map(personDoc => {
        return {
          documentID: personDoc.data().documentID,
          id: personDoc.id,
          name: personDoc.data().name,
          phoneNumber: personDoc.data().phoneNumber
        }
      })
      const answers = answerQuery.docs.map(doc => {
        const answer = doc.data()
        const personData = persons.find(person => {
          return person.id === answer.personID
        })
        return {
          labels: answer.answers.s8bjYTD8jQz3rVpDuA9a.labels,
          name: personData?.name,
          timestamp: answer.timestamp.toDate()
        }
      })
      const rows = [['Fecha', 'Nombre']]
      for (const answer of answers) {
        const date = moment(answer.timestamp).format('YYYY-MM-DD')
        rows.push([date, answer.name, ...answer.labels])
      }
      console.info(rows)
      const wb = XLSX.utils.book_new()
      const name = 'Salud Mental.xlsx'
      const w1 = XLSX.utils.aoa_to_sheet(rows)
      XLSX.utils.book_append_sheet(wb, w1, 'registros')

      const wopts = { bookType: 'xlsx', bookSST: false, type: 'array' }
      const wbout = XLSX.write(wb, wopts)
      const xlsx = new Blob([wbout], { type: 'application/octet-stream' })
      saveAs(xlsx, name)
    },
    setPopulationBinds () {
      this.bindedPopulations = []
      if (this.newPopulationHistoryStructure) {
        for (const population of this.selectedPopulations) {
          if (this.bindedPopulations.indexOf(population.id) === -1) {
            this.bindedPopulations.push(population.id)
            this.populationBindings.push(db.collection('populationHistory').doc(this.instanceID).collection('history').doc(`${population.id}${moment(this.date).tz('America/Bogota').startOf('day').format('x')}`)
              .onSnapshot(snap => {
                if (snap.exists) {
                  this.$store.commit('admin/setSpecificPopulationHistory', { populationID: population.id, data: snap.data() })
                } else {
                  this.$store.commit('admin/setSpecificPopulationHistory', { populationID: population.id, data: {} })
                }
              }, (err) => { console.info(err.code) }))
            this.$store.commit('admin/setPopulationHistory', {})
          }
        }
      }
    },
    exportAllPopulations () {
      try {
        const todayDate = moment(this.date).tz('America/Bogota').startOf('day').format('DD-MM-YY')
        const wb = XLSX.utils.book_new()
        const name = `Cuidarte-General-${todayDate}.xlsx`
        const statistics = [
          [''],
          ['Miembros'],
          ['Reportes'],
          ['Asintomáticos'],
          ['Sintomáticos']
        ]
        for (const population of this.selectedPopulations) {
          const populationTags = this.getPopulationTags(population)
          statistics[0].push(populationTags)
          const personCount = this.populationHistory[population.id] ? this.populationHistory[population.id].personIDs?.length || 0 : population.personCount || 0
          const reportedCount = this.populationHistory[population.id]?.reported?.length || 0
          const symptomaticCount = this.populationHistory[population.id]?.symptomatic?.length || 0
          const asymptomaticCount = reportedCount - symptomaticCount
          const reportedPercentage = !personCount ? 0 : Math.round(reportedCount / personCount * 100)
          const asymptomaticPercentage = !personCount ? 0 : Math.round(asymptomaticCount / personCount * 100)
          const symptomaticPercentage = !personCount ? 0 : Math.round(symptomaticCount / personCount * 100)
          statistics[1].push(personCount)
          statistics[2].push(`(${reportedCount}) ${reportedPercentage}%`)
          statistics[3].push(`(${asymptomaticCount}) ${asymptomaticPercentage}%`)
          statistics[4].push(`(${symptomaticCount}) ${symptomaticPercentage}%`)
        }
        const w1 = XLSX.utils.aoa_to_sheet(statistics)
        XLSX.utils.book_append_sheet(wb, w1, todayDate)

        const wopts = { bookType: 'xlsx', bookSST: false, type: 'array' }
        const wbout = XLSX.write(wb, wopts)
        const xlsx = new Blob([wbout], { type: 'application/octet-stream' })

        if (typeof window.plugins !== 'undefined') {
          var reader = new FileReader()
          this.$f7.dialog.preloader('Cargando...')
          reader.readAsDataURL(xlsx)
          reader.onloadend = () => {
            this.$f7.dialog.close()
            const base64data = reader.result
            window.plugins.socialsharing.share(
              null,
              null,
              this.generateAttachment(base64data, name),
              null,
              (result) => { console.info('result: ' + result) },
              (result) => { console.info('error: ' + result) }
            )
          }
        } else {
          saveAs(xlsx, name)
        }
      } catch (err) {
        console.info(err)
        this.$f7.dialog.alert('Hubo un problema descargando este informe', 'Error')
      }
    },
    getPopulationTags (population) {
      const tagNames = []
      for (const tagID in population.tagIDs) {
        tagNames.push(this.instancesInfo[this.instanceID].tags[tagID])
      }
      return tagNames.sort().join(', ')
    },
    async historyExport () {
      const initDate = moment('1609459200', 'X').toDate()
      const endDate = moment('1617235200', 'X').toDate()
      const symptomsQuery = await db.collection('symptoms').where('instanceID', '==', this.instanceID)
        .where('dateTimestamp', '>', initDate).where('dateTimestamp', '<', endDate).get()
      const rows = [['Fecha', 'Respuestas', 'En riesgo']]
      if (!symptomsQuery.empty) {
        for (const symptomsDoc of symptomsQuery.docs) {
          const date = moment(symptomsDoc.data().dateTimestamp.toMillis()).format('YYYY-MM-DD')
          const reported = symptomsDoc.data().reportedCount || 0
          const risk = symptomsDoc.data().symptomaticCount || 0
          rows.push([date, reported, risk])
        }
      }
      const wb = XLSX.utils.book_new()
      const name = 'Uso(Enero-Febrero-Marzo).xlsx'
      const w1 = XLSX.utils.aoa_to_sheet(rows)
      XLSX.utils.book_append_sheet(wb, w1, 'registros')

      const wopts = { bookType: 'xlsx', bookSST: false, type: 'array' }
      const wbout = XLSX.write(wb, wopts)
      const xlsx = new Blob([wbout], { type: 'application/octet-stream' })
      saveAs(xlsx, name)
    },
    clearBindings () {
      this.clearPopulationBindings()
      this.$store.commit('admin/deleteLastSymptomsDay')
      for (const binding of this.bindings) {
        binding()
      }
    },
    clearPopulationBindings () {
      for (const binding of this.populationBindings) {
        binding()
      }
      this.populationBindings = []
    },
    selectID (id) {
      this.selectedID = id
    },
    togglePopulationCRUD () {
      this.showingPopulationCRUD = !this.showingPopulationCRUD
    },
    async bindPopulationsInfo () {
      this.clearBindings()
      moment.locale('es')
      const today = moment(this.date).tz('America/Bogota').startOf('day')
      const promises = []
      for (let i = 0; i < 13; i++) {
        today.subtract(1, 'days')
        promises.push(db.collection('symptoms').doc(this.instanceID + today.format('x')).get())
      }
      const results = await Promise.allSettled(promises)
      for (const promiseResult of results) {
        if (promiseResult.status === 'fulfilled') {
          const result = promiseResult.value
          if (result.exists) {
            this.$store.commit('admin/setLastSymptomsDay', { data: result.data(), id: result.data().dateTimestamp.toMillis() })
          }
        }
      }
      this.bindings.push(db.collection('symptoms').doc(this.instanceID + moment(this.date).tz('America/Bogota').startOf('day').format('x'))
        .onSnapshot(todaySymptoms => {
          if (todaySymptoms.exists) {
            if (todaySymptoms.exists) {
              this.$store.commit('admin/setLastSymptomsDay', { data: todaySymptoms.data(), id: todaySymptoms.data().dateTimestamp.toMillis() })
            }
          }
        }, (err) => {
          const data = {
            dateTimestamp: timestamp.fromMillis(moment(this.date).tz('America/Bogota').startOf('day').format('x')),
            instanceID: this.instanceID,
            reported: [],
            reportedCount: 0,
            riskyPersons: {},
            symptomaticCount: 0,
          }
          this.$store.commit('admin/setLastSymptomsDay', { data, id: moment(this.date).tz('America/Bogota').startOf('day').format('x') })
          console.info(err.code)
        }))
      this.bindings.push(db.collection('populationHistory').doc(`${this.instanceID}${moment(this.date).tz('America/Bogota').startOf('day').format('x')}`)
        .onSnapshot(snap => {
          if (snap.exists) {
            console.info(snap.data())
            this.newPopulationHistoryStructure = false
            this.$store.commit('admin/setPopulationHistory', snap.data())
          } else {
            this.newPopulationHistoryStructure = true
          }
          this.setPopulationBinds()
        }, (err) => {
          this.newPopulationHistoryStructure = true
          this.setPopulationBinds()
          console.info(err.code)
        }))
    },
  },
}
</script>
<style lang="scss" scoped>
@import "../css/_brand";
.list-enter-active, .list-leave-active {
  transition: all 1s;
}
.list-enter, .list-leave-to /* .list-leave-active for <2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
</style>
